import './WhatsappWidget.module.css'

const WhatsappPopup = (props) => {
    return (
        <>
            <div className="whatsapp-chat-box lg:hidden">
                <div className="whatsapp-chat-box-header">
                    <div>
                        <div style={{color:"white",fontWeight:"bold"}}>Exploro</div>
                    </div>
                </div>
                <div className="whatsapp-chat-box-content">
                    <p>Hi, there!<br />How can We help you?</p>
                    <a href={props.whatsappLink} onClick={() => {
                        props.setIsVisible(false)
                        }
                    } target="_blank" rel="noopener noreferrer">
                        Start Chat
                    </a>
                </div>
            </div>
        </>
    )
}

export default WhatsappPopup;